import React, { useState } from "react";

// Mock data for products
const productData = [
  {
    srNo: 1,
    productName: "Nestle Coffee Gold",
    productCode: "3109",
    productMRP: 150,
    sellPrice: 180,
    productImage: "",
    sgst: 0,
    cgst: 0,
    minimumMargin: 0,
    status: "Active",
  },
  {
    srNo: 2,
    productName: "Nestle Coffee",
    productCode: "3108",
    productMRP: 80,
    sellPrice: 90,
    productImage: "",
    sgst: 0,
    cgst: 0,
    minimumMargin: 0,
    status: "Active",
  },
];

const ProductApprove = () => {
  const [employeeId, setEmployeeId] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [productList, setProductList] = useState(productData);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Submitted");
    console.log("Employee Id:", employeeId);
    console.log("Start Date:", startDate);
    console.log("End Date:", endDate);
  };

  const handleStatusChange = (srNo, newStatus) => {
    const updatedList = productList.map((item) =>
      item.srNo === srNo ? { ...item, status: newStatus } : item
    );
    setProductList(updatedList);
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.header}>Approve Product</h2>

      <form onSubmit={handleSubmit} style={styles.form}>
        <div style={styles.formGroup}>
          <label style={styles.label}>Employee Id</label>
          <input
            type="text"
            value={employeeId}
            onChange={(e) => setEmployeeId(e.target.value)}
            required
            style={styles.input}
          />
        </div>
        <div style={styles.formGroup}>
          <label style={styles.label}>Start Date</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            required
            style={styles.input}
          />
        </div>
        <div style={styles.formGroup}>
          <label style={styles.label}>End Date</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            required
            style={styles.input}
          />
        </div>
        <button type="submit" style={styles.submitButton}>
          Submit
        </button>
      </form>

      <div style={styles.tableContainer}>
        <table style={styles.table}>
          <thead>
            <tr style={styles.tableHeaderRow}>
              <th style={styles.tableHeader}>Sr No.</th>
              <th style={styles.tableHeader}>Product Name</th>
              <th style={styles.tableHeader}>Product Code</th>
              <th style={styles.tableHeader}>Product MRP</th>
              <th style={styles.tableHeader}>Sell Price</th>
              <th style={styles.tableHeader}>SGST</th>
              <th style={styles.tableHeader}>CGST</th>
              <th style={styles.tableHeader}>Minimum Margin</th>
              <th style={styles.tableHeader}>Status</th>
              <th style={styles.tableHeader}>Action</th>
            </tr>
          </thead>
          <tbody>
            {productList.map((product) => (
              <tr key={product.srNo} style={styles.tableRow}>
                <td style={styles.tableCell}>{product.srNo}</td>
                <td style={styles.tableCell}>{product.productName}</td>
                <td style={styles.tableCell}>{product.productCode}</td>
                <td style={styles.tableCell}>{product.productMRP}</td>
                <td style={styles.tableCell}>{product.sellPrice}</td>
                <td style={styles.tableCell}>{product.sgst}</td>
                <td style={styles.tableCell}>{product.cgst}</td>
                <td style={styles.tableCell}>{product.minimumMargin}</td>
                <td style={styles.tableCell}>{product.status}</td>
                <td style={styles.tableCell}>
                  <button
                    onClick={() => handleStatusChange(product.srNo, "Approved")}
                    style={styles.approveButton}
                  >
                    Approve
                  </button>
                  <button
                    onClick={() => handleStatusChange(product.srNo, "Rejected")}
                    style={styles.rejectButton}
                  >
                    Reject
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "1200px",
    margin: "20px auto",
    padding: "20px",
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
  },
  header: {
    textAlign: "center",
    fontSize: "24px",
    color: "#2c3e50",
    marginBottom: "20px",
  },
  form: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gap: "15px",
    marginBottom: "30px",
  },
  formGroup: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    marginBottom: "8px",
    fontSize: "14px",
    fontWeight: "bold",
    color: "#34495e",
  },
  input: {
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "5px",
    fontSize: "14px",
    color: "#34495e",
  },
  submitButton: {
    gridColumn: "span 3",
    padding: "10px 15px",
    backgroundColor: "#3498db",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "16px",
    transition: "background-color 0.3s ease",
  },
  tableContainer: {
    overflowX: "auto",
    marginTop: "20px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    borderRadius: "8px",
    overflow: "hidden",
  },
  tableHeaderRow: {
    backgroundColor: "#2c3e50",
    color: "#fff",
  },
  tableHeader: {
    padding: "12px",
    textAlign: "left",
    fontSize: "14px",
  },
  tableRow: {
    backgroundColor: "#f9f9f9",
    transition: "background-color 0.3s ease",
  },
  tableCell: {
    padding: "12px",
    border: "1px solid #ddd",
    fontSize: "14px",
  },
  approveButton: {
    backgroundColor: "#27ae60",
    color: "#fff",
    padding: "6px 12px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "14px",
    marginRight: "10px",
    transition: "background-color 0.3s ease",
  },
  rejectButton: {
    backgroundColor: "#e74c3c",
    color: "#fff",
    padding: "6px 12px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "14px",
    transition: "background-color 0.3s ease",
  },
};

export default ProductApprove;
